<mat-card-content>
  <div class="table-responsive">
    <table *ngIf="this.dataSourceOwners.data.length >= 1" mat-table [dataSource]="dataSourceOwners"
      class="mat-elevation-z8">

      <ng-container matColumnDef="fullRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">RUT</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fullRut }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="th-title">Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name ? element.name : '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef class="th-title">Apellido</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastName ? element.lastName : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="participation">
        <th mat-header-cell *matHeaderCellDef class="th-title">Participacion</th>
        <td mat-cell *matCellDef="let element">
          {{ element.participation ? element.participation + '%' : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="civilState">
        <th mat-header-cell *matHeaderCellDef class="th-title">Estado Civil</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.civilState ? element?.civilState : "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef class="th-title">Edad</th>
        <td mat-cell *matCellDef="let element">
          {{ element.age ? element.age : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="aval">
        <th mat-header-cell class="th-title" *matHeaderCellDef style="text-align: center;">
          AVAL
        </th>
        <td mat-cell *matCellDef="let element" class="td-text-content">         
          <div *ngIf="!showTd(element.fullRut); else spinner">
            <i-tabler *ngIf="element.aval == true " name="circle-check-filled" class="icon-20"
              (click)="toggleDebtorResolutionChange($event, element.fullRut, element.aval)"
              (click)="showTd(element.fullRut)"              
              [ngClass]="{'disabled': minuteRequestRealTime?.finalResolutionName == 'Cancelada' || minuteRequestRealTime?.finalResolutionName == 'Rechazado'}"
              style="color: mediumspringgreen; cursor: pointer;"></i-tabler>
            <i-tabler *ngIf="element.aval == false" name="circle-x" class="icon-20"
              [ngClass]="{'disabled': minuteRequestRealTime?.finalResolutionName == 'Cancelada' || minuteRequestRealTime?.finalResolutionName == 'Rechazado'}"
              (click)="toggleDebtorResolutionChange($event, element.fullRut, element.aval)"
              (click)="showTd(element.fullRut)"
              style="color: rgb(250, 0, 0); cursor: pointer"></i-tabler>
          </div>
        </td>
        <ng-template #spinner >
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </ng-container>

      <ng-container matColumnDef="rl">
        <th mat-header-cell *matHeaderCellDef class="th-title">RL</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler *ngIf="element.rl == true" name="circle-check-filled" class="icon-20"
            style="color: mediumspringgreen"></i-tabler>
          <i-tabler *ngIf="element.rl == false" name="circle-x" class="icon-20"
            style="color: rgb(250, 0, 0)"></i-tabler>
          <i-tabler *ngIf="element.rl == null" name="circle-filled" class="icon-20"
            style="color: rgb(142, 142, 142)"></i-tabler>
        </td>
      </ng-container>

      <ng-container matColumnDef="dicom">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element">
          {{element.dicom | currency:'CLP':'symbol'}}
          <ng-template #notDicom>S/info</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="dicomReporter">
        <th mat-header-cell *matHeaderCellDef class="th-title">Reporte</th>
        <td mat-cell *matCellDef="let element">
          <a *ngIf="element.dicom != undefined; else notDicom" href="{{this.getReportUrl(element.fullRut)}}"
            target="_blank"><mat-icon matSuffix class="dicomReport">feed</mat-icon></a>
          <ng-template #notDicom>S/info</ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsOwners"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsOwners"></tr>
    </table>

    <div *ngIf="this.dataSourceOwners.data.length < 1">
      <h3 style="text-align: center;"> No se encontraron Socios </h3>
    </div>

  </div>
</mat-card-content>